<template>
    <div class="history__queue">
        <div v-if="items.length > 0">
            <history-queue-item v-for="item in getCurrentPageItems()" :key="item.username" :counsellors="counsellors"
                :item="item">
            </history-queue-item>
        </div>
        <div v-else class="alert alert-primary">
            <i class="far fa-bells"></i> There are currently no students in queue items for the specified date.
        </div>
    </div>
</template>

<script>
import HistoryQueueItem from './QueueItem';

export default {
    name: 'history-queue',
    components: {
        HistoryQueueItem,
    },
    props: {
        counsellors: {
            type: Array,
            required: true
        },
        currentPage: {
            type: Number
        },
        items: {
            type: Array,
            required: true
        },
        perPage: {
            type: Number
        }
    },
    methods: {
        getCurrentPageItems() {
            let from = (this.currentPage * this.perPage) - this.perPage;
            let to = (this.currentPage * this.perPage);
            return this.items.slice(from, to);
        }
    }
}
</script>

<style scoped>
.history-queue__item {
    padding-top: .5rem;
    padding-bottom: .5rem;
    border-bottom: 1px solid #f0f3ff;
}

.history-queue__item:last-child {
    border: none;
}
</style>